import Breadcrumb from 'components/Navigation/Breadcrumb';
import React from 'react';
import { useAppSelector } from 'store/hooks';
import { selectAccountDetails } from 'selectors/account-selector';
import CompleteDashboard from './CompleteDashboard';
import InCompleteDashboard from './InCompleteDashboard';

export default function Home() {
  const { user } = useAppSelector(selectAccountDetails);

  return (
    <div>
      <Breadcrumb title="Your Dashboard Today" />
      {(user && user.isStepCompleted) || user.onBoardingSkip ? (
        <CompleteDashboard />
      ) : (
        <InCompleteDashboard />
      )}
    </div>
  );
}
